module.exports = __webpack_public_path__ + "media/service_features/project-ac579ad3.svg";